/* eslint-disable */
import React, { useMemo, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { CTitle } from '../../components/Widget';
import { useUpdateComponentState } from '../../../hooks';
import ImgPoint from '../../../../../../assets/2025/arrow.gif';
import phishingSide from '../../../../../../assets/finance/topic1400/section1_1.png';
import Quiz from '../../components/Quiz';

interface Settings {
  paragraphs: any[];
}

interface ISection2Props {
  settings: Settings;
}

const Section2: React.FunctionComponent<ISection2Props> = ({ settings }) => {
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(() => {
    const list = settings?.paragraphs as any[] | undefined;
    if (!list?.length) return undefined;
    const found = list.find((p: any) =>
      p?.id===ID
    );
    return found ?? list[2];
  }, [settings?.paragraphs]);

  const updateComponentState = useUpdateComponentState();
  const [visibleCount, setVisibleCount] = useState(1);
  const [animationStarted, setAnimationStarted] = useState(false);

  const handleArrowClick = () => {
    if (!animationStarted) {
      setAnimationStarted(true);
      setVisibleCount(2);
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'finance-topic1400-section2-1'
      );
    }
  };

  useEffect(() => {
    if (!animationStarted) return;
    const len = paragraphsSettings?.risks?.length ?? 0;
    if (visibleCount >= len) return;
    const timer = setTimeout(() => setVisibleCount((v) => v + 1), 600);
    return () => clearTimeout(timer);
  }, [visibleCount, animationStarted, paragraphsSettings?.risks?.length]);

  const [state, setState] = useState({
    play: 1,
    factorPlay: 1,
    isFactorPlayed: false,
    quiz: false,
  });
  const startFactorPlay = (next = 1) => {
    if (state.isFactorPlayed) {
      return;
    }
    next += 1;
    setState({ ...state, factorPlay: next, isFactorPlayed: true });
    if (next <= 5) {
      setTimeout(() => startFactorPlay(next), 500);
    } else {
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'finance-topic1400-section2-2'
      );
    }
  };


  const MoreConciseComponent = () => (
    <>
      {paragraphsSettings?.l2Lists?.map((item:any, index:number) => (
        <div className="prevent-deepfake-item" key={index}>
            <span className="code">
              {item.code}
            </span>
           <span className="text">{item.text}</span>
        </div>
      ))}
    </>
  );

  return (
    <div className="topic-section-2">
      {/* section1 part2 */}
      <div className="prevent-deepfake">
        <CTitle title={paragraphsSettings?.title ?? ''} />
        <div
          className="prevent-deepfake-talk"
          dangerouslySetInnerHTML={{
            __html: paragraphsSettings?.l2Text1 ?? '',
          }}
        ></div>
        <div className="prevent-deepfake-list">
          <div className="prevent-deepfake-list-box">
            <MoreConciseComponent />
          </div>
        </div>
      </div>
      <div className="tampering" id="finance-topic1400-section2-1">
        <div className="content">
          {!animationStarted && (
            <img className="arrow-img" src={ImgPoint} alt="" />
          )}

          <div className="right-pic">
            <div className="risks-title">{paragraphsSettings?.risksTitle}</div>
            <img src={phishingSide} alt="" />
          </div>
          <div className="left-list" onClick={handleArrowClick}>
            {paragraphsSettings?.risks?.map((r: any, i: number) => (
              <div
                key={i}
                className="risk-item"
                data-show={i < visibleCount}
                style={{
                  cursor:
                    i === 0 && !animationStarted ? 'pointer' : 'default',
                }}
              >
                <div className="risk-title">
                  <span>{r.title}</span>
                </div>
                <div className="risk-desc">
                  <div className="risk-desc-text">{r.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="examples-of-phishing-fraud">
        <div className="examples-of-phishing-fraud-title">
          <p>{paragraphsSettings?.l1Title}</p>
          <p>{paragraphsSettings?.l1SubTitle}</p>
        </div>

        <div className="examples-of-phishing-fraud-content">
          <div className="examples-of-phishing-fraud-left"></div>
          <div className="examples-of-phishing-fraud-right">
            <div className="content-list">
              {paragraphsSettings?.l1Lists?.map((item:any) => (
                <div key={String(item.id)} className="content-item">
                  <div className="content-item-day">{item.day}</div>
                  <div className="content-item-text">
                    {item.text}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div
        className="factor-content"
        id="finance-topic1400-section2-2"
        onClick={() => startFactorPlay()}
      >
        {state.factorPlay <= 1 && (
          <img src={ImgPoint} alt="" className="img-point" />
        )}
        <div className="factor-tips">{paragraphsSettings?.l4Tip}</div>
        {paragraphsSettings?.l4?.map((item: string, i: number) => (
          <div
            className={`factor-item factor-item-${i + 1} ${
              state.factorPlay > i ? 'box-fade-right-in' : ''
            }`}
            key={i}
          >
            <span>{item}</span>
          </div>
        ))}
      </div>
      {/* question */}
      <div
        id="finance-topic1400-section2-question"
        className="topic-quiz"
      >
        <Quiz
          title={paragraphsSettings?.questionTitle ?? ''}
          description={paragraphsSettings?.quiz?.description ?? ''}
          question={paragraphsSettings?.quiz?.question ?? ''}
          options={paragraphsSettings?.quiz?.options ?? []}
          onCompleted={() => {
            setState({ ...state, quiz: true });
            updateComponentState(
              p_course,
              p_topic,
              ID,
              'finance-topic1400-section2-question'
            );
          }}
        />
      </div>
    </div>
  );
};

export default Section2;
